const slider = document.querySelectorAll(".slider");

slider?.forEach((slider) => {
  const sliderWrapper = slider.querySelector(".slider__wrapper");
  const sliderContainer = slider.querySelector(".slider__container");
  const sliderNav = slider.querySelector(".slider__nav");
  let slidePrev;
  let slideNext;

  const itemWidth =
    sliderContainer?.querySelector(".slider__item")?.offsetWidth;

  const isAligned = slider?.classList.contains("slider--aligned");

  if (isAligned && window.innerWidth > 1280) {
    (() => {
      console.dir(sliderContainer);
      let div = document.createElement("div");
      sliderContainer?.prepend(div);
      div.style.display = "block";
      div.style.backgroundColor = "transparent";
      const sliderGap = sliderContainer
        ? parseFloat(getComputedStyle(sliderContainer).columnGap) || 0
        : 0;

      div.style.flex = `0 0 ${(window.innerWidth - 1280) / 2 - sliderGap}px`;
      div.classList.add("slider__item");
      div.classList.add("slider__item--placeholder");

      if (sliderContainer) {
        sliderContainer.scrollLeft = 0;
      }
    })();
  }

  if (sliderNav) {
    slidePrev = sliderNav.querySelector(".slider__prev");
    slideNext = sliderNav.querySelector(".slider__next");
  }

  const watchNavState = () => {
    if (sliderContainer) {
      if (sliderContainer.scrollLeft === 0) {
        slidePrev.classList.remove("active");
      } else {
        slidePrev.classList.add("active");
      }
      if (
        sliderContainer.scrollLeft + sliderWrapper.offsetWidth >=
        sliderContainer.scrollWidth
      ) {
        slideNext.classList.remove("active");
      } else {
        slideNext.classList.add("active");
      }
    }
  };

  if (sliderNav) watchNavState();

  if (slideNext) {
    slideNext.addEventListener("click", () => {
      watchNavState();
      if (
        sliderContainer.scrollLeft + sliderWrapper.offsetWidth <
        sliderContainer.scrollWidth
      ) {
        sliderContainer.scrollLeft += itemWidth * 1.5;
      } else {
      }
    });
  }
  if (slidePrev) {
    slidePrev.addEventListener("click", () => {
      watchNavState();
      if (
        sliderContainer.scrollLeft - sliderWrapper.offsetWidth <
        sliderContainer.scrollWidth
      ) {
        sliderContainer.scrollLeft -= itemWidth * 1.5;
      } else {
      }
    });
  }
});

//HTML STRUCTURE

/* <div class="slider">
  <div class="slider__wrapper">
    <div class="slider__container">
      <div class="slider__item">
        ...ITEM
        </div>
      <div class="slider__item">
        ...ITEM
        </div>
      <div class="slider__item">
        ...ITEM
        </div>
    </div>
  </div>
  <div class="slider__nav">
    <div class="slider__prev">
      <div class="icon-arrow-left"></div>
    </div>
    <div class="slider__next">
      <div class="icon-arrow-right"></div>
    </div>
  </div>
</div> */
